<template>
  <b-row>
    <b-col md="12" class="text-right">
      <b-button variant="link" @click="logout" class="text-gray">{{
        $t("logout")
      }}</b-button>
    </b-col>
  </b-row>
</template>
<script>
export default {
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout", this.form)
        .then(() => this.$router.push({ name: "login" }));
    }
  }
};
</script>
